import React from "react";
import styled from "styled-components";
import { content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Icon from "@ui-kit/icon";
import { tr } from "@radarly/i18n";

export const IFrame = styled.iframe<{ height: number }>`
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : "100%")};
  border: 0;
`;

const ErrorWrapper = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;
  height: 100%;
  color: ${content};
`;

export function EmbeddedError({ locale }: { locale: Locale }) {
  return (
    <ErrorWrapper>
      <Icon glyph="ghost" size="96px" />
      <p>{tr(locale, "EMBEDDED_CARD_ERROR")}</p>
    </ErrorWrapper>
  );
}
